import { NextSeo } from "next-seo";
const Hippa = () => {
  return (
    <div className="container main-blog text-center section-gap">
      <NextSeo
        title="HIPAA Notice | NextMed"
        description="We are comply with the law and follow Health Insurance Portability and Accountability Act (HIPAA) and the Health Information Technology for Economic and Clinical Health Act (HITECH) set of standard."
        canonical="https://www.nextmed.com/HIPAA_notice"
      />
      <h2 className="">HIPAA Notice</h2>
      <p className="font-weight-bold">
        This notice describes how medical information about you may be used and
        disclosed and how you can get access to this information. Please review
        it carefully.
      </p>
      <p>Updated November 29th, 2021</p>
      <p className="text-bold">
        “We,” “us,” and “our” refers to, and this Notice applies to, medical
        groups that provide healthcare services and laboratories. These medical
        groups, including but not limited to Beluga Health CO PA, Beluga Health Corp, Beluga Health PC, Beluga Health PA, Beluga Health PC, Beluga Health PC, Beluga Health PC of New Jersey, may employ
        or contract with physicians who offer certain healthcare services.
      </p>
      <p className="font-weight-bold">You are provided with the following:</p>
      <p>
        Request a copy of your records. Ask for a copy of your test result as
        well as other PHI that was obtained during the process of registration
        and testing.
      </p>
      <p>
        Request a correction to your records. Ask us to correct your health and
        claims records if you think they are incorrect or incomplete.
      </p>
      <p>
        Request confidential communications. Ask us to contact you in a specific
        way (for example, home or office phone) or to send mail to a different
        address.
      </p>
      <p>
        Restriction request. We reserve the right to decline such requests
        unless the requested restriction involves disclosure to a health plan
        and you have paid for the services out of pocket.
      </p>
      <p>
        Provide access to a trusted party. If you have given someone medical
        power of attorney or if someone is your legal guardian, that person can
        exercise your rights and make choices about your health information.
      </p>
      <p>
        Request a list of those with whom we’ve shared information. Ask us for a
        list (accounting) of the times we’ve shared your health information for
        six years prior to the date you ask, who we shared it with, and why.
        This request has to be presented in writing.
      </p>
      <p>
        Request a list of those with whom we’ve shared information. Ask us for a
        list (accounting) of the times we’ve shared your health information for
        six years prior to the date you ask, who we shared it with, and why.
        This request has to be presented in writing.
      </p>
      <p className="font-weight-bold">Uses and Disclosures.</p>
      <p>
        The Health Insurance Portability and Accountability Act (HIPAA) and the
        Health Information Technology for Economic and Clinical Health Act
        (HITECH) set the standard for sensitive patient data protection. We
        typically use or share your health information in the following ways
      </p>
      <p>
        Help manage the health care treatment you receive. We can use your
        health information and share it with medical professionals who are
        treating you.
      </p>
      <p>The information we collect, why we need it, and how we use it.</p>
      <p>
        Help manage the health care treatment you receive. We can use your
        health information and share it with medical professionals who are
        treating you.
      </p>
      <p>
        Comply with the law and help with public health and safety issues. We
        will share information about you if state or federal laws require it,
        including with local health departments and with the Department of
        Health and Human Services if it wants to see that we’re complying with
        federal privacy law.
      </p>
      <p>
        Comply with the law and help with public health and safety issues. We
        will share information about you if state or federal laws require it,
        including with local health departments and with the Department of
        Health and Human Services if it wants to see that we’re complying with
        federal privacy law.
      </p>
      <p className="font-weight-bold">Our Responsibilities</p>
      <p>
        We are required by law to maintain the privacy and security of your
        protected health information.
      </p>
      <p>
        {" "}
        We must follow the duties and privacy practices described in this notice
        and give you a copy of it.
      </p>
      <p>
        We will not use or share your information other than as described here
        unless you tell us we can in writing. If you tell us we can, you may
        change your mind at any time. Let us know in writing at
        team@joinnextmed.com if you change your mind.
      </p>
    </div>
  );
};
export default Hippa;
